<template>
  <div>
    <div class="page_content page_content_reg">
      <div class="change_regserver_content">
        <div class="change_password_content_title">服务方注册</div>
        <div class="change_password_content_form_wrap">
          <el-form ref="ruleForm" :model="ruleForm" status-icon label-width="150px" class="demo-ruleForm">
            <el-form-item label="姓名" prop="name" :rules="[
            { required: true, message: '请输入姓名'},
          ]">
              <el-input placeholder="请输入姓名" style="width: 336px;" type="text" v-model="ruleForm.name"
                autocomplete="off" maxLength="30"></el-input>
            </el-form-item>
            <el-form-item label="用户名" prop="userName" :rules="[
            { required: true, validator: checkUserName, trigger: 'blur'},
          ]">
              <el-input placeholder="请输入用户名" style="width: 336px;" type="text" v-model="ruleForm.userName"
                autocomplete="off" maxLength="30"></el-input>
            </el-form-item>
            <el-form-item :rules="[
            { required: true, message: '请输入密码'},
          ]" label="密码" prop="pass">
              <el-input placeholder="请输入6-16位密码，区分大小写" style="width: 336px;" type="password" v-model="ruleForm.pass"
                autocomplete="off" maxLength="16"></el-input>
            </el-form-item>
            <el-form-item :rules="[
            { required: true, validator: checkPass, trigger: 'blur'},
          ]" label="确认密码" prop="checkPass">
              <el-input placeholder="请再次输入密码" style="width: 336px;" type="password" v-model="ruleForm.checkPass"
                autocomplete="off" maxLength="16"></el-input>
            </el-form-item>
            <el-form-item label="服务方类型" prop="userType" :rules="[
            { required: true},
          ]">
              <el-radio-group v-model="ruleForm.userType">
                <el-radio :label="2">公司</el-radio>
                <el-radio :label="3">个人</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="ruleForm.userType === 2" :rules="[
            { required: true, message: '请输入公司名称'},
          ]" label="公司名称" prop="company">
              <el-input placeholder="请输入正确的公司全称" style="width: 336px;" type="text" v-model="ruleForm.company"
                autocomplete="off"  maxLength="50"></el-input>
            </el-form-item>
            <div class="service_register_upload__wrap">
              <el-form-item :rules="[
              { required: true, message: '请上传身份证'},
            ]" label="身份证件">
                <el-upload class="upload-demo" :action="fileurl_1" :multiple="false" :limit="2" :file-list="fileList_sfz" :before-remove="beforeRemove"
                  accept="image/jpg,image/jpeg,image/png" :before-upload="beforeUpload" :on-success="handleSuccess">
                  <div slot="trigger" class="service_register_upload">
                    <i class="el-icon-circle-plus"></i>
                    <span v-if="ruleForm.userType === 2">上传公司法人身份证</span>
                    <span v-else>上传身份证</span>
                  </div>
                </el-upload>
              </el-form-item>
              <div class="service_register_upload_tip">
                请上传JPG/PNG文件大小不超过2M
              </div>
              <img class="service_register_upload_demo" :src="pic_sfz" />
            </div>
            <div class="service_register_upload__wrap" v-if="ruleForm.userType === 2">
              <el-form-item :rules="[
              { required: true, message: '请上传营业执照'},
            ]" label="营业执照">
                <el-upload class="upload-demo" :action="fileurl_2" :multiple="false" :limit="2" :file-list="fileList_yyzz" :before-remove="beforeRemove"
                  accept="image/jpg,image/jpeg, image/png" :before-upload="beforeUpload" :on-success="handleSuccess">
                  <div slot="trigger" class="service_register_upload" >
                    <i class="el-icon-circle-plus"></i>
                    <span>上传公司营业执照</span>
                  </div>

                </el-upload>
              </el-form-item>
              <div class="service_register_upload_tip">
                请上传JPG/PNG文件大小不超过2M
              </div>
              <img class="service_register_upload_demo" :src="pic_yyzz" />
            </div>

            <div class="service_register_upload__wrap" v-if="ruleForm.userType === 2">
              <el-form-item :rules="[
              { required: true, message: '请上传公司介绍'},
            ]" label="公司介绍">
                <el-upload class="upload-demo" :action="fileurl_3" :multiple="false" :limit="2" :file-list="fileList_gsjs" :before-remove="beforeRemove"
                  accept="application/pdf,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation" :before-upload="beforeUpload_1" :on-success="handleSuccess">
                  <div slot="trigger" class="service_register_upload" >
                    <i class="el-icon-circle-plus"></i>
                    <span>上传公司公司介绍</span>
                  </div>

                </el-upload>
              </el-form-item>
              <div class="service_register_upload_tip">
                请上传PDF/PPT/PPTX文件大小不超过50M
              </div>
              <!-- <img class="service_register_upload_demo" :src="pic_yyzz" /> -->
            </div>

            <div class="service_register_upload__wrap" v-if="ruleForm.userType === 3">
              <el-form-item :rules="[
              { required: true, message: '请上传个人履历'},
            ]" label="个人履历">
                <el-upload class="upload-demo" :action="fileurl_4" :multiple="false" :limit="2" :file-list="fileList_grll" :before-remove="beforeRemove"
                  accept="application/pdf,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation" :before-upload="beforeUpload_1" :on-success="handleSuccess">
                  <div slot="trigger" class="service_register_upload" >
                    <i class="el-icon-circle-plus"></i>
                    <span>上传公司个人履历</span>
                  </div>

                </el-upload>
              </el-form-item>
              <div class="service_register_upload_tip">
                请上传PDF/PPT/PPTX文件大小不超过50M
              </div>
              <!-- <img class="service_register_upload_demo" :src="pic_yyzz" /> -->
            </div>

            <div class="service_register_upload__wrap" >
              <el-form-item :rules="[
              { required: true, message: '请上传ratecard'},
            ]" label="ratecard">
                <el-upload class="upload-demo" :action="fileurl_5" :multiple="false" :limit="2" :file-list="fileList_ratecard" :before-remove="beforeRemove"
                  accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" :before-upload="beforeUpload_2" :on-success="handleSuccess">
                  <div slot="trigger" class="service_register_upload" >
                    <i class="el-icon-circle-plus"></i>
                    <span>请上传ratecard</span>
                  </div>

                </el-upload>
              </el-form-item>
              <div class="service_register_upload_tip">
                请上传XLS/XLSX文件大小不超过50M
              </div>
              <!-- <img class="service_register_upload_demo" :src="pic_yyzz" /> -->
            </div>

            <el-form-item v-if="ruleForm.userType === 2" :rules="[
            { required: true, message: '请选择团队规模'},
          ]" label="团队规模" prop="teamSize">
              <el-select style="width: 334px;" v-model="ruleForm.teamSize" placeholder="请选择团队规模">
                <el-option :key="key" :label="item.label" :value="item.value" v-for="(item,key) in team_size_dict">
                </el-option>
            </el-select>
            </el-form-item>
            <el-form-item :rules="[
            { required: true, message: '请选择地区范围'},
          ]" label="地区" prop="regional_scope">
              <el-select style="width: 334px;" v-model="ruleForm.regional_scope" placeholder="请选择所在地区范围" @change="changeRegionalScope" >
                <el-option label="国内" :value="1"></el-option>
                <el-option label="海外" :value="2"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="客户地区" prop="area" v-if="ruleForm.regional_scope == 1" :rules="[
            { required: true,validator: checkArea_1, trigger: 'blur'},]">
              <div class="block">
                <el-cascader v-model="shengshi_arr" :options="shengshi_data" @change="handleChange"
                  placeholder="请选择客户地区" style="width: 334px">
                </el-cascader>
              </div>
            </el-form-item>
            <el-form-item label="客户地区" prop="area" v-if="ruleForm.regional_scope == 2" :rules="[
            { required: true,validator: checkArea_2, trigger: 'blur'},]">
              <el-select v-model="ruleForm.area" placeholder="请选择客户地区"  style="width: 334px">
                <el-option :key="key" :label="item.label" :value="item.value" v-for="(item,key) in overseas_area_dict">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="是否提供驻场服务" prop="isOnsite" :rules="[
            { required: true},
          ]">
              <el-radio-group v-model="ruleForm.isOnsite">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="2">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item :rules="[
            { required: true, message: '请输入邮箱'},
            {type:'email',message: '请输入正确的邮箱地址'}
          ]" label="邮箱" prop="email">
              <el-input placeholder="请输入正确的邮箱地址" style="width: 336px;" type="text" v-model="ruleForm.email"
                autocomplete="off"   maxLength="40"></el-input>
            </el-form-item>
            <el-form-item :rules="[
            { required: true,validator: checkPhone, trigger: 'blur'}
          ]" label="手机号" prop="telphone">
              <el-input placeholder="请输入手机号" style="width: 336px;" type="text" v-model="ruleForm.telphone"
                autocomplete="off"   maxLength="11">
                <template slot="prepend">+86</template>
              </el-input>
            </el-form-item>
            <el-form-item label="滑动验证">
              <SlideVerify ref="slideVerify" @passed="onSlidePassed" width="336px" />
            </el-form-item>
            <el-form-item :rules="[
            { required: true, message: '请输入验证码'},
          ]" label="验证码" prop="code">
              <el-input placeholder="请输入验证码" style="width: 336px;" type="text" v-model="ruleForm.code"
                autocomplete="off"  maxLength="10">
                <template slot="append">
                  <div class="brand_register_code_btn" @click="getyzm" >{{ titlename }}</div>
                </template>

              </el-input>
            </el-form-item>
            <el-form-item :rules="[
            { validator: checkIsRead, trigger: 'blur'},
          ]" prop="isRead">
              <div>
                <el-checkbox checked v-model="ruleForm.isRead"></el-checkbox>
                我已阅读并同意 <el-button @click="dialogVisible = true" type="text">《服务方用户注册协议》</el-button>
              </div>
            </el-form-item>
            <el-form-item>
              <el-button style="height: 40px;padding: 8px 152px;" type="primary" @click="submitForm('ruleForm')"
                :disabled="form_disabled">注册</el-button>
              <div style="text-align: center;width: 334px;">
                <!-- <el-button type="text">使用已有账号登录</el-button> -->
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <el-dialog title="星云平台用户注册协议" :visible="dialogVisible" :before-close="handleClose">
      <div>
        <h3>1、导言</h3>
        欢迎您使用由“”（以下简称“公司”）合法运营并享有知识产权的
        “星云平台”。《星云平台用户注册协议》（以下简称“本协议”）是您
        与公司之间就您以下载、安装、注册、登录、发布信息、浏览、交流
        等方式使用（以下统称“使用”）“星云平台”提供的相关服务所订立
        的协议。
        为了您可以更好享受“星云平台”提供的服务，在使用“星云平台”
        前，请您认真阅读并充分理解本协议，特别是涉及免除或者限制责任
        的条款、法律适用和争议解决条款等。如您不接受本协议的条款或内
        容，您将无法享受完整的“星云平台”提供的产品和服务，您也可以
        选择停止使用；但若您使用了“星云平台”，您的使用行为将被视为
        您已认真阅读且透彻理解并完全同意本协议条款及“星云平台”的全
        部规定，且承诺遵守。
        若您未满18周岁，请在法定监护人的陪同下阅读本协议及本协议提
        及的相关协议，并在使用本服务前获得您法定监护人的书面同意。
        <h3>2、定义</h3>
        <p>2.1账号：指您在本网站注册并使用的账号。</p>
        <p>
          2.2星云平台/我们：指由众多创意方和品牌客户共同组成的信息分
          享、传播、交换平台，创意方通过手机、PC等多种移动终端接入，
          以短视频、图片、文档等多媒体形式分享自己的作品。
        </p>
        <p>
          2.3创意方/您：指能够独立创作脚本、策略、slogan等并依法享有署
          名权的自然人或法人，在依法完成注册并成功入驻星云平台后可自由
          使用星云平台的主体。
        </p>
        <p>
          2.4品牌客户：指通过使用星云平台的展示、浏览、设计、交流等功
          能，最终直接或者间接向您发出合作邀请或者与您达成合作意向的自
          然人或法人。
        </p>

        <p>
          2.5项目：指通过借助星云平台的功能，由您与品牌客户达成合作的
          具体项目。
        </p>
        <p>
          2.6跳单：指的是您基于星云平台的功能与品牌客户就具体项目达成
          了合作意向，为了规避支付服务费而跳过星云平台私下与品牌客户达
          成合作或者获得收益的行为。
        </p>
        <h3>3、协议的接受与确认</h3>
        <p>
          3.1您可以通过搜索名称为“星云平台”的网站（访问网址为：）
          及标注名称为“星云平台”的客户端应用程序使用平台展示、交流等
          功能。
        </p>
        <p>
          3.2为了您能更便捷的享受星云平台提供的服务，您需知悉并同意在
          注册账号过程中，同意本协议及与本协议密切相关的《隐私协议》，
          如您坚持并完成账号注册，后期使用账号的行为将受本协议与隐私政
          策的约束。另外，我们会不定期的对星云平台提供的服务进行更新或
          者改变，更新或者改变后如您继续使用星云平台，则视为您完全同意
          并理解更新或者改变后的星云平台及运行规则。
        </p>
        <h3>4、账号注册与使用</h3>
        <p>
          4.1您申请注册、登陆星云平台时，需要您提供并填写真实、准确、
          有效的注册信息，并按照要求设置账号密码。注册成功后，您申请的
          账号和密码是您享受星云平台服务的唯一合法凭证。您有责任对账号
          及密码进行定期维护，并对账号下的一切操作行为承担法律责任。一
          旦发现未经许可擅自使用您账号的情况，请您第一时间修改账号密
          码，并及时通知我们。
        </p>
        <p>
          4.2您注册的帐号仅限于您本人使用，未经星云平台书面同意，禁止
          以任何形式赠与、借用、出租、转让、售卖或以其他方式许可他人使
          用该帐号。如果出现前述情形，我们有权在未通知您的情况下，暂停
          或终止向该注册帐号提供服务，并有权注销该帐号，而无需向注册该
          帐号的用户承担法律责任。
        </p>
        <p>
          4.3为了符合国家的相关法律法规或政策，同时更好的享受星云平台
          提供的服务，在登陆、使用星云平台时，请您填写、提供真实、有效、
          合法的信息材料，如我们发现有任何不真实、不合法的信息材料出现，
          我们有权拒绝为您提供服务，同时，如触犯法律，我们将移交司法、
          行政等权力机关进行相应处理，同时保留因您提供信息材料不真实、
          不合法给我们造成损失的权利。
        </p>
        <p>
          4.4特别提示您在使用星云平台时不得制作、上传、复制、发布、传
          播或者转载如下内容：（1）反对宪法所确定的基本原则的；（2）危害
          国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；（3）损
          害国家荣誉和利益的；（4）煽动民族仇恨、民族歧视，破坏民族团结
          的；（5）破坏国家宗教政策，宣扬邪教和封建迷信的；（6）散布谣言，
          扰乱社会秩序，破坏社会稳定的；（7）散布淫秽、色情、赌博、暴力、
          凶杀、恐怖或者教唆犯罪的；（8）侮辱或者诽谤他人，侵害他人合法
          权益的；（9）侵害未成年人合法权益或者损害未成年人身心健康的；
          （10）含有法律、行政法规禁止的其他内容的信息。
        </p>
        <p>
          4.5为提高曝光率、增加合作几率，您同意将您在星云平台发布、上
          传的全部内容授权我们以同一账号自动发送至我们合法运营的其他
          平台、网站（例如：APP/小程序等），您的账号之头像、昵称等公开
          信息亦将同步公开。您在星云平台账号的发布、修改、删除等操作也
          将同步反映在在前述平台、网站。
        </p>
        <h3>5、个人信息保护</h3>
        <p>
          个人信息保护是我们不断前进的动力和坚守的底线，我们将与您一同
          致力于您个人信息（能够独立或与其他信息结合后识别、锁定您身份
          的信息）的保护。您在使用星云平台提供的服务时，需要您提供相应
          信息，我们将利用现代技术手段进行加密、匿名化等处理，更多保护
          措施请详见《隐私政策》。
        </p>
        <h3>6、服务</h3>
        <p>
          6.1星云平台提供的服务是我们根据现行政策及实际情况做出的，我
          们有权利保留变更、中断或终止部分或全部服务的权利。我们不承担
          因业务调整给您造成的损失。除非本协议另有其它明示规定，增加或
          强化目前星云平台的任何新功能，包括所推出的新产品，均受到本协
          议之规范。如您不接受服务调整，请停止使用本服务；否则，您的继
          续使用行为将被视为对服务调整的完全同意且承诺遵守。
        </p>
        <p>
          6.2您在星云平台可免费享受作品展示功能。另外，星云平台也提供
          部分增值服务，如商机推荐、商机前期沟通、商机协调等服务。增值
          服务属于额外收费服务，我们会在相关页面上做明确的提示。如您拒
          绝使用增值服务或者不同意增值服务的费用、费用标准，请您不要勾
          选相应的选项及相关操作，与此同时，您将无法享受增值服务。
        </p>
        <p>
          6.3为更好的实现星云平台运行的目标，我们将设置业务咨询通道及
          联系专线，为您解答在使用星云平台时遇到的各类问题。
        </p>
        <p>
          6.4您理解，我们提供的服务仅限于现行星云平台的功能和开发程
          度，请您自行准备使用星云平台所需要的设备（电脑、手机等）及承
          担所需费用（如电费、网费等）。
        </p>
        <p>
          6.5星云平台提供的服务内容可能包括：文字、软件、声音、图片、
          视频、图表、音乐等。所有这些内容受著作权、商标和其它财产所有
          权法律的保护。您只有在获得我们或其他相关权利人的授权之后才能
          使用这些内容，不能擅自复制、再造这些内容、或创造与内容有关的
          派生产品。
        </p>
        <h3>7、行为规范</h3>
        <p>7.1在您使用星云平台服务前，您需承诺：</p>
        <p>（1）您上传、发布的信息、作品必须符合国家法律法规和政策的要
          求，并同时符合星云平台的相关规定，不违法、违规或侵犯任何第三
          方的合法权益；</p>
        <p>（2）您的上传、发布行为和上传发布的信息、作品享有或已获得所
          必须的全部权利和授权，并不存在任何已有的或可能存在的侵权行
          为、纠纷或诉讼等；</p>
        <p>
          （3）您在使用星云平台服务的过程中，有可能获得星云平台的部分
          信息（包括但不限于公司信息、公司商业政策或其他任何信息等）。
          前述信息都属于我们的商业秘密，您不会将上述信息泄露、转让、有
          偿或无偿提供给第三方；
        </p>
        <p>
          （4）您承诺，您将合法合理地使用本服务，不会利用本服务从事违
          法、违规或侵权事宜，包括但不限于洗钱、赌博、套现或金融诈骗等。
        </p>
        <p>
          （5）您保证上传、发布的信息、作品、链接的安全性，不包含任何
          病毒、蠕虫、木马或类似损害程序代码的内容。
        </p>
        <p>
          7.2您理解并同意，我们有权对您使用星云平台上传、发布的信息、
          作品及使用行为等进行实时监控，如存在前述情况，我们有权在您提
          供合法有效的证明或其他合理解决方案之前对您上传、发布的信息、
          作品、案例采取屏蔽、删除等处理措施或以单方通知的形式暂停或终
          止向您提供星云平台服务。如因此给我们造成任何损失，有权向您追
          偿。
        </p>
        <p>
          7.3您理解，除非提前与我们达成协议，否则不得在星云平台为第三
          方网站、产品或服务发布推广信息、广告产品/链接等。任何在星云
          平台发布的网页地址链接必须符合我们的要求，且仅能为展示您作品
          集的网页链接。
        </p>
        <p>
          7.4您同意并承诺，除非提前与我们达成协议，否则您不会自行或授
          权、允许、协助任何第三人对星云平台提供相关服务中的数据信息内
          容进行如下任何行为：
        </p>
        <p>（1）使用（包括但不限于复制、读取、采用）星云平台的服务及数
          据信息内容；</p>
        <p>
          （2）将星云平台提供服务中获取的数据信息内容以任何方式公示、
          提供、泄露给任何第三人或用于本协议之外的目的；
        </p>
        <p>
          （3）擅自编辑、整理、编排星云平台中获取的数据信息内容，用于
          其他平台、网站等渠道进行展示或使用；
        </p>
        <p>（4）以爬虫、蜘蛛、机器人等软件程序获得星云平台的数据。</p>

        <p>
          7.5为更好的为您提供服务，您同意并承诺，凡属于合作协议中界定
          的“品牌客户”，应及时向我们反馈并支付相应的服务费，避免因任
          何原因出现隐瞒、欺诈的情况。一旦出现跳单，我们有权单方终止您
          使用账号、享受星云平台服务，并有权根据实现情况保留追究其他法
          律责任的权利。
        </p>
        <h3>8、知识产权</h3>
        <p>
          8.1公司是星云平台及本协议的知识产权权利人。星云平台服务中产
          生的一切著作权、商标权、专利权、商业秘密等知识产权，以及相关
          的所有信息内容（包括但不限于文字、图片、界面设计、版面框架等）
          均由公司享有，本协议另行约定、或按照相关法律法规规定由其他权
          利人享有的除外。
        </p>
        <p>
          8.2您需要确保在星云平台上传、发布的信息、作品、链接（含文字、
          图片、图像、音频、视频、图表、版面设计、logo、电子文档等）为
          您原创，产生的知识产权及相关权利属于您所有。我们尊重您对于您
          所上传、发布的信息、作品、链接的相关知识产权权利，包括但不限
          于著作权、商标权等。
        </p>
        <p>
          8.3您同意并理解，为持续改善星云平台的服务质量，您在星云平台
          上传、发布的信息、作品、链接等内容（包括但不限于数据、文字、
          图片、图像、音频、视频和/或音频中的音乐、声音、对话等），授权
          公司在全球范围内、免费、非独家、可再许可的权利（包括但不限于
          复制权、信息网络传播权、改编权、汇编权、修改权、翻译权），使
          用在公司运营维护的当前或其他网站、应用程序、产品或终端设备等。
        </p>
        <h3>9、保密义务</h3>
        <p>
          9.1您理解并同意，您和我们对本协议条款、技术信息、经营信息等
          信息负有同样的保密义务。保密信息包括但不限于星云平台接口技
          术、安全协议及证书等。
        </p>
        <p>
          9.2您一旦选择使用星云平台，意味着您认可并同意签署本协议，任
          何一方在事先未经对方书面同意的情况下，不得向任何第三方披露、
          泄漏任何对方的保密信息；否则应当承担法律责任。
        </p>
        <p>
          9.3无论何种原因导致您停止使用星云平台、注销账号等，您和我们
          对本协议条款、技术信息、经营信息等信息仍负有保密义务，保密期
          限不因任何原因而消除、中止、终结。
        </p>
        <h3>10、免责声明</h3>
        <p>
          10.1因您提供、上传的信息、作品、链接等内容不符本协议要求，
          导致任何第三方向您进行的追索、诉讼等，我们不承担法律责任。尽
          管我们在您上传信息、作品、链接等内容时会进行初步的审核，但是
          该审核行为并不免除您应承担的法律责任。此外，因您的行为导致公
          司因此陷入纠纷、诉讼的，您应积极采取处理措施，以避免公司因此
          卷入纠纷、承担损失。
        </p>
        <p>
          10.2无论品牌客户以何种方式通过星云平台或者公司运营的其他平
          台、网站获取信息，最终与您达成项目合作，因此产生的任何争议、
          纠纷均与公司无关，您同意豁免我们（以及我们的员工、经理、代理
          人、分公司、合资企业和其他雇员）对从该纠纷中产生的所有类型的
          诉请和赔偿的全部责任。
        </p>
        <p>
          10.3您在星云平台中使用第三方提供的软件及相关服务时，除需遵
          守本协议及其他相关规则外，还可能需要同意并遵守第三方的协议、
          相关规则。如因第三方服务产生的争议、损失或损害，由您自行与第
          三方解决，公司并不就此而对您或任何第三方承担任何责任。
        </p>
        <h3>11、违约责任</h3>
        <p>
          11.1针对您违反本协议或其他规范的行为，公司有权独立判断并视
          情况采取预先警示、立即停止传输信息、限制账号部分或者全部功能
          直至永久关闭账号等措施。
        </p>
        <p>
          11.2因您违反本协议或者其他相关规范、协议导致品牌客户等第三
          方提起诉讼、索赔等，您应自行处理并承担全部可能由此引起的法律
          责任；如因您的侵权行为导致公司及其关联公司遭受损失的（包括经
          济、商誉等损失），您还应足额赔偿公司及其关联公司遭受的全部损
          失。
        </p>
        <h3>12、关于单项服务及第三方服务</h3>
        <p>
          12.1星云平台为您提供服务中可能涉及一些单项服务或者第三方
          服务，这些服务存在的目的是为您提供更好的服务体验及效果。公司
          有权对这些服务不时地增加、减少或改动。
        </p>
        <p>
          12.2单项服务及第三方服务的开通需要通过您的同意，并且额外收
          取一定费用，需要您慎重考虑是否使用，一旦您开始使用上述服务，
          则视为您理解并接受有关单项服务的相关协议、规则的约束。
        </p>
        <h3>13、其他</h3>
        <p>13.1本协议的订立、效力、解释、适用、争议解决等一切事宜，均
          适用中华人民共和国大陆地区法律。</p>
        <p>
          13.2因本协议产生的任何争议应友好协商解决，如无法解决或者无
          法达成一致的，任何一方有权向北京市朝阳区人民法院提起诉讼。
        </p>
        <p>
          13.3为更好的为您服务及适应国家法律法规、政策调整，本协议、
          星云平台及其运行规则会不时的更新与调整。调整后的新版本我们也
          会在星云平台及时予以发布，如您继续使用星云平台，则视为您同意
          更新后的协议、星云平台及其运行规则。如您不同意或者有任何异议，
          请您立即停止登录或使用星云平台。如您不同意或者有异议，却仍继
          续使用星云平台，则视为您完全同意并接受。
        </p>
        <p>
          13.4您和公司均是独立的主体，在任何情况下本协议不构成公司对
          用户的任何形式的明示或暗示担保或条件，双方之间亦不构成代理、
          合伙、合营或雇佣关系。
        </p>

      </div>
    </el-dialog>
  </div>
</template>
<script>
/* eslint-disable */
  import * as commfun from "@/common/common.js"
  import index_mixins_shengshi from "@/common/mixins/index_mixins_shengshi.js"
  import axios from "axios"
  import SlideVerify from "@/components/SlideVerify.vue"
  export default {
    name: 'RegServer',
    mixins: [index_mixins_shengshi],
    components: { SlideVerify },
    data() {
      return {
        dialogVisible: false,
        checked: true,
        ruleForm: {
          name: '',
          userName: '',
          userType: 2,
          pass: '',
          checkPass: '',
          company: '',
          email: '',
          telphone: '',
          code: '',
          isOnsite: 1,
          regional_scope: '',
          area: '',
          teamSize: '',
          identity_sfz: '',
          identity_yyzz: '',
          identity_gsjs: '',
          identity_grll: '',
          identity_ratecard: '',
          isRead: true,
        },
        second: '', // 倒计时秒
        disabled: false, //倒计时停用按钮
        timer: null, //计时器
        yzm: '', //验证码
        form_disabled: false,
        overseas_area_dict: [],  // 海外地区字典
        team_size_dict: [],  // 团队规模字典
        shengshi_data: [],//省市数据
        shengshi_arr: [],  // 省市数组
        //pic_sfz: "../assets/img/identity_demo.png",
        temp_pic_sfz: require('@/assets/img/identity_demo.png'),
        temp_pic_yyzz: require('@/assets/img/form_demo_2.png'),
        pic_sfz:"",
        pic_yyzz:"",
        fileurl_1: "/api/api/login/upload?mtype=2",//身份证件类型附件
        fileurl_2: "/api/api/login/upload?mtype=3",//营业执照类型附件
        fileurl_3: "/api/api/login/upload?mtype=4",//公司介绍类型附件
        fileurl_4: "/api/api/login/upload?mtype=5",//个人履历类型附件
        fileurl_5: "/api/api/login/upload?mtype=6",//ratecard类型附件
        fileList_sfz:[],
        fileList_yyzz:[],
        fileList_gsjs:[],
        fileList_grll:[],
        fileList_ratecard:[],
        slidePassed: false,
        slideToken: '',

      };
    },
    created: function () {
      this.pic_sfz = this.temp_pic_sfz
      this.pic_yyzz = this.temp_pic_yyzz
      //省市数据加载
      this.getShengShi();
      //this.initData()
    },
    mounted() {
      this.get_dict()
    },
    computed: {
      titlename() {
        return this.disabled ? this.second + "s" : '获取验证码';
      }
    },
    methods: {
      // 获取字典
      get_dict() {
        var selfthis = this;
        var url = '/api/api/login/dict';
        var postdata = {}
        commfun.ajaxPost(selfthis, url, postdata, function (selfthis, data) {
          console.log(data)
          selfthis.overseas_area_dict = data.overseas_area_dict
          selfthis.team_size_dict = data.team_size_dict
          selfthis.DicFileTypes = data.annex_dict
          return true
        }, function (selfthis, dataError) {
          selfthis.disabled = false
          commfun.showMessage(selfthis, 'warning', "错误：" + dataError.msg)
        })

      },
      /** 省市快捷搜索结束 */
      handleChange(value) {
        console.log("省市级联数据:" + value);
        this.ruleForm.area = this.shengshi_arr[0] + ',' + this.shengshi_arr[1]
      },
      // 切换地区范围
      changeRegionalScope() {
        this.ruleForm.area = ''
        if (this.ruleForm.regional_scope == 2) {
          this.shengshi_arr = []
        }
      },
      checkIsRead(rule, value, callback) {
        if(value === false){
          callback(new Error('请阅读并同意用户注册协议'));
        } else {
          callback();
        }
      },
      checkArea_1(rule, value, callback) {
        var regional_scope=this.ruleForm.regional_scope //1 国内 2国外
        if (regional_scope==1&&value === '') {
          callback(new Error('请选择地区范围'));
        } else {
          callback();
        }
      },
      checkArea_2(rule, value, callback) {
        var regional_scope=this.ruleForm.regional_scope //1 国内 2国外
        if (regional_scope==2&&value === '') {
          callback(new Error('请选择地区范围'));
        } else {
          callback();
        }
      },
      checkPhone(rule, value, callback) {
        if (value === '') {
          callback(new Error('手机号码不能为空'));
        } else if (!this.alidatePhone(value)) {
          callback(new Error('手机号码不正确'));
        } else {
          callback();
        }
      },
      checkUserName(rule, value, callback) {
        if (value === '') {
          callback(new Error('请再次用户名'));
        } else if (!this.alidateInputUserName(value)) {
          callback(new Error('用户名仅支持输入英文字母和数字，限制输入最多30个字符'));
        } else {
          callback();
        }
      },
      checkPass(rule, value, callback) {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.ruleForm.pass) {
          callback(new Error('两次输入密码不一致!'));
        } else if (!this.alidateInput(value)) {
          callback(new Error('密码仅支持输入英文字母和数字，限制输入6-16字符'));
        } else {
          callback();
        }
      },
      alidatePhone(textInput) {
        let regex = /^1[3456789]\d{9}$/;
        if (!regex.test(textInput)) {
          return false;
        }
        return true;
      },
      alidateInputUserName(textInput) {
        let regex = /^[a-zA-Z0-9]{1,30}$/;
        if (!regex.test(textInput)) {
          return false;
        }
        return true;
      },
      //判断新密码仅支持输入英文字母和数字，限制输入6-16字符
      alidateInput(textInput) {
        let regex = /^[a-zA-Z0-9]{6,16}$/;
        if (!regex.test(textInput)) {
          return false;
        }
        return true;
      },
      getyzm: function () {
        let selfthis = this
        if (!selfthis.ruleForm.telphone) {
          commfun.showMessage(selfthis, 'warning', '请输入手机号码!')
          return false;
        }
        if (!selfthis.slidePassed) {
          commfun.showMessage(selfthis, 'warning', '请先完成滑动验证')
          return false;
        }
        if (!selfthis.slideToken) {
          commfun.showMessage(selfthis, 'warning', '滑块凭证异常，请刷新重试')
          return false;
        }
        selfthis.sendSms(selfthis, selfthis.ruleForm.telphone);
        // 倒计时 控制start
        let s = 60 // 倒计时 1分钟
        if (!selfthis.timer) {
          console.log('--start--')
          selfthis.second = s
          selfthis.disabled = true
          selfthis.timer = setInterval(() => {
            if (selfthis.second > 0 && selfthis.second <= s) {
              selfthis.second--
            } else {
              selfthis.disabled = false
              clearInterval(selfthis.timer)
              selfthis.timer = null
            }
          }, 1000)
        }

      },
      onSlidePassed (token) {
        this.slidePassed = true
        this.slideToken = token
      },
      sendSms: function (selfthis, telphone) {
        console.log(selfthis.disabled)
        if(selfthis.disabled == true){
          console.log("倒计时还没完成")
          return false
        }
        // var url = "/api/site/sendsms2?phone="+this.telphone+"&sys_type=biginhouse&type=index_inhouse"
        var url = "/api/api/login/sendsms"
        var postdata = { phone: telphone, slide_token: selfthis.slideToken }
        commfun.ajaxPost(selfthis, url, postdata, function (selfthis, data) {
          console.log(data)
          commfun.showMessage(selfthis, 'success', "成功：" + "短信发送成功")

          return true
        }, function (selfthis, dataError) {
          selfthis.disabled = false
          commfun.showMessage(selfthis, 'warning', "错误：" + dataError.msg)
        })


      },
      beforeUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 2;
        const isJPG = file.type === 'image/jpeg';
        const isPNG = file.type === 'image/png';
        if (!isLt2M) {
          this.$message.error('上传文件大小不能超过 2MB!');
          return false;
        }
        if (!isJPG && !isPNG) {
         this.$message.error('上传图片只能是 JPG/PNG 格式!');
         return false;
        }
        return isLt2M;
      },
      beforeUpload_1(file) {//pdf,ppt,pptx
        const isLt50M = file.size / 1024 / 1024 < 50;
        const isPDF = file.type === 'application/pdf';
        const isPPT = file.type === 'application/vnd.ms-powerpoint';
        const isPPTX = file.type === 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
        if (!isLt50M) {
          this.$message.error('上传文件大小不能超过 50MB!');
          return false;
        }
        if (!isPDF && !isPPT&& !isPPTX) {
         this.$message.error('上传图片只能是 PDF/PPT/PPTX 格式!');
         return false;
        }
        return isLt50M;
      },
      beforeUpload_2(file) {//xls/xlsx
        const isLt50M = file.size / 1024 / 1024 < 50;
        const isXLS = file.type === 'application/vnd.ms-excel';
        const isXLSX = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        if (!isLt50M) {
          this.$message.error('上传文件大小不能超过 50MB!');
          return false;
        }
        if (!isXLS && !isXLSX) {
         this.$message.error('上传图片只能是 XLS/XLSX 格式!');
         return false;
        }
        return isLt50M;
      },
      beforeRemove(file){
        console.log("beforeRemove")
        console.log(file.response)
        if(file.response!=undefined){
          if(file.response.data.mtype==2){
            this.pic_sfz = this.temp_pic_sfz
          }else if(file.response.data.mtype==3){
            this.pic_yyzz = this.temp_pic_yyzz
          }
        }


        return true
      },
      handleSuccess(response, file, fileList) {
        console.log("handleSuccess")
        console.log(response, file, fileList);
        if (response.code!='1000'){
          this.$message.error(response.msg);
          return false;
        }
        if (response.data.mtype == 2) { //身份证件类型附件
          this.pic_sfz = response.data.fileUrl
          this.ruleForm.identity_sfz = response.data.filestr
          this.fileList_sfz = fileList.slice(-1); // 只保留最后一个文件
        } else if (response.data.mtype == 3) { //营业执照类型附件
          this.pic_yyzz = response.data.fileUrl
          this.ruleForm.identity_yyzz = response.data.filestr
          this.fileList_yyzz = fileList.slice(-1); // 只保留最后一个文件
        }else if (response.data.mtype == 4) { //公司介绍
          //this.pic_yyzz = response.data.fileUrl
          this.ruleForm.identity_gsjs = response.data.filestr
          this.fileList_gsjs = fileList.slice(-1); // 只保留最后一个文件
        }else if (response.data.mtype == 5) { //个人履历类型附件
          //this.pic_yyzz = response.data.fileUrl
          this.ruleForm.identity_grll = response.data.filestr
          this.fileList_grll = fileList.slice(-1); // 只保留最后一个文件
        }else if (response.data.mtype == 6) { //ratecard类型附件
          //this.pic_yyzz = response.data.fileUrl
          this.ruleForm.identity_ratecard = response.data.filestr
          this.fileList_ratecard = fileList.slice(-1); // 只保留最后一个文件
        }

      },
      submitUpload() {
        this.$refs.upload.submit();
      },
      submitForm(formName) {
        var selfthis = this
        if (!selfthis.slidePassed) {
          commfun.showMessage(selfthis, 'warning', '请先完成滑动验证')
          return false;
        }
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if(!selfthis.ruleForm.identity_sfz){
              commfun.showMessage(selfthis, 'warning', "错误：请上传身份证件类型附件")
              return false;
            }
            if(selfthis.ruleForm.userType=="2"&&!selfthis.ruleForm.identity_yyzz){
              commfun.showMessage(selfthis, 'warning', "错误：请上传营业执照类型附件")
              return false;
            }
            if(selfthis.ruleForm.userType=="2"&&!selfthis.ruleForm.identity_gsjs){
              commfun.showMessage(selfthis, 'warning', "错误：请上传公司介绍类型附件")
              return false;
            }
            if(selfthis.ruleForm.userType=="3"&&!selfthis.ruleForm.identity_grll){
              commfun.showMessage(selfthis, 'warning', "错误：请上传个人履历类型附件")
              return false;
            }
            if(!selfthis.ruleForm.identity_ratecard){
              commfun.showMessage(selfthis, 'warning', "错误：请上传ratecard类型附件")
              return false;
            }
            var url = '/api/api/login/toRegServer'
            selfthis.form_disabled = true
            var postdata = selfthis.ruleForm
            commfun.ajaxPost(selfthis, url, postdata, function (selfthis, data) {
              console.log(data)
              commfun.showMessage(selfthis, 'success', "注册成功！请等待审核通过后登录。")
              setTimeout(function () {
                window.location.href = "/"
              }, 100)
              return true
            }, function (selfthis, dataError) {
              selfthis.form_disabled = false
              commfun.showMessage(selfthis, 'warning', "错误：" + dataError.msg)
            })

          } else {
            selfthis.form_disabled = false
            //commfun.showMessage(selfthis, 'warning', "错误：" + dataError.msg)
            return false;
          }
        });

      },
      handleClose(done) {
        this.dialogVisible = false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/RegServer.vue